/* eslint-disable import/prefer-default-export */

export const DEFAULT_360_IMAGE_SIZE =
  'cdn-cgi/image/width=1280,quality=95,format=webp';
